import React from 'react';
import { IFacetValue } from '@components/pages/ShopV3/model/SearchResults';
import AttributeFamilyFilter
  from '@components/pages/ShopV3/components/Filters/AttributeFamilyFilter/AttributeFamilyFilter';
import { hashCode } from '@lib/string';

export interface IAttributeFamilies {
  attributeFamilyFilters: Record<string, IFacetValue[]>;
  selectedFilterIds: string[];
  onFilterSelected: (value: IFacetValue) => void;
}

interface IAttributeFamilyFilter {
  selectedFilterIds: string[];
  onFilterSelected: (value: IFacetValue) => void;
  className?: string;
  attributeFamilyFilters: Record<string, IFacetValue[]>;
}

const AttributeFamilyFilters = ({
  className,
  selectedFilterIds,
  onFilterSelected,
  attributeFamilyFilters,
}: IAttributeFamilyFilter) => {
  return (
    <>
      {
        Object.keys(attributeFamilyFilters)
          .map((parent) => {
            return (
              <div key={hashCode(parent)}>
                <AttributeFamilyFilter
                  parent={parent}
                  onFilterSelected={onFilterSelected}
                  facets={attributeFamilyFilters[parent]}
                  selectedFilterIds={selectedFilterIds}
                  classname={className}
                />
              </div>
            );
          })
      }
    </>
  );
};

export default AttributeFamilyFilters;
